export default __webpack_public_path__ + "logo.7f6bdb83e69e45c3d216356195848541.png";